module.exports = "images/doc-activity-add-empty-2.49f02f876a53395fc5f0c76cbe2aa80e.png";